import { useAiSettings, useRbacPrimaryRolePermissions } from "../../../api/hooks";
import { useFeatureFlagQuery } from "../../../hooks/useFeatureFlag";

export const useReportBuilderVisible = (): boolean => {
	const { value: aiEnabled } = useFeatureFlagQuery("ff-is-ai-enabled", false);
	const { value: conversationalEnabled } = useFeatureFlagQuery("ff-is-conversational-ui-enabled", false);
	const { value: reportBuilderEnabled } = useFeatureFlagQuery("ff-is-ai-report-builder-enabled", false);

	const { data: aiSettings } = useAiSettings();
	const { data: permissions } = useRbacPrimaryRolePermissions("report_analytics");

	const interviewerEnabled = aiSettings?.conversationalAiSettings?.interviewerEnabled ?? false;
	const canCreateReport = permissions?.includes("report_analytics:createReport") ?? false;

	return aiEnabled && conversationalEnabled && interviewerEnabled && reportBuilderEnabled && canCreateReport;
};
